/**
 * Schema of Carga Cielo
 * @author ftgibran
 */
import {$, cep, phone, rg, cpfOrCnpj, datetime, InputType, Schema, cnpj} from 'simpli-web-sdk'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'
import CargaCielo from '@/model/resource/CargaCielo'

export default (model: CargaCielo): Schema => ({
  codeServiceType: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.codeServiceType || '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('codeServiceType'),
          value: model.codeServiceType || '-',
        },
      },
    ],
    textContent: model.codeServiceType || '-',
    input: InputType.TEXT,
  },

  dataInicioEntrega: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.dataInicioEntrega ? datetime(model.dataInicioEntrega) : '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('dataInicioEntrega'),
          value: model.dataInicioEntrega ? datetime(model.dataInicioEntrega) : '-',
        },
      },
    ],
    textContent: model.dataInicioEntrega ? datetime(model.dataInicioEntrega) : '-',
    input: InputType.TEXT,
  },

  dataPrevisao: {
      content: [
          {
              component: RenderLabelValue,
              props: {
                  value: model.dataPrevisao ? datetime(model.dataPrevisao) : '-',
              },
          },
          {
              component: RenderLabelValue,
              props: {
                  label: model.translateColumn('dataPrevisao'),
                  value: model.dataPrevisao ? datetime(model.dataPrevisao) : '-',
              },
          },
      ],
      textContent: model.dataPrevisao ? datetime(model.dataPrevisao) : '-',
      input: InputType.TEXT,
    },

  dataFinalizacao: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.dataFinalizacao ? datetime(model.dataFinalizacao) : '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('dataFinalizacao'),
          value: model.dataFinalizacao ? datetime(model.dataFinalizacao) : '-',
        },
      },
    ],
    textContent: model.dataFinalizacao ? datetime(model.dataFinalizacao) : '-',
    input: InputType.TEXT,
  },

  status: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.textoStatusFinal || '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('status'),
          value: model.textoStatusFinal || '-',
        },
      },
    ],
    textContent: model.textoStatusFinal || '-',
    input: InputType.TEXT,
  },

  tipoDeRemessa: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.tipoDeRemessa || '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('tipoDeRemessa'),
          value: model.tipoDeRemessa || '-',
        },
      },
    ],
    textContent: model.tipoDeRemessa || '-',
    input: InputType.TEXT,
  },

  tipoOcorrenciaSucesso: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.tipoOcorrenciaSucesso && model.tipoOcorrenciaSucesso.$tag || '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('tipoOcorrenciaSucesso'),
          value: model.tipoOcorrenciaSucesso && model.tipoOcorrenciaSucesso.$tag || '-',
        },
      },
    ],
    textContent: model.tipoOcorrenciaSucesso && model.tipoOcorrenciaSucesso.$tag || '-',
    input: InputType.TEXT,
  },

  merchantID: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.merchantID || '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('merchantID'),
          value: model.merchantID || '-',
        },
      },
    ],
    textContent: model.merchantID || '-',
    input: InputType.TEXT,
  },

  logicalNumber: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.logicalNumber || '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('logicalNumber'),
          value: model.logicalNumber || '-',
        },
      },
    ],
    textContent: model.logicalNumber || '-',
    input: InputType.TEXT,
  },

  referenceCode: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.referenceCode || '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('referenceCode'),
          value: model.referenceCode || '-',
        },
      },
    ],
    textContent: model.referenceCode || '-',
    input: InputType.TEXT,
  },

  businessName: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.businessName || '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('businessName'),
          value: model.businessName || '-',
        },
      },
    ],
    textContent: model.businessName || '-',
    input: InputType.TEXT,
  },

  legalEntityName: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.legalEntityName || '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('legalEntityName'),
          value: model.legalEntityName || '-',
        },
      },
    ],
    textContent: model.legalEntityName || '-',
    input: InputType.TEXT,
  },

  address: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.address || '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('address'),
          value: model.address || '-',
        },
      },
    ],
    textContent: model.address || '-',
    input: InputType.TEXT,
  },

  neighborhood: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.neighborhood || '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('neighborhood'),
          value: model.neighborhood || '-',
        },
      },
    ],
    textContent: model.neighborhood || '-',
    input: InputType.TEXT,
  },

  city: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.city || '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('city'),
          value: model.city || '-',
        },
      },
    ],
    textContent: model.city || '-',
    input: InputType.TEXT,
  },

  state: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.state || '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('state'),
          value: model.state || '-',
        },
      },
    ],
    textContent: model.state || '-',
    input: InputType.TEXT,
  },

  addressCode: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.addressCode ? cep(model.addressCode) : '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('addressCode'),
          value: model.addressCode ? cep(model.addressCode) : '-',
        },
      },
    ],
    textContent: model.addressCode ? cep(model.addressCode) : '-',
    input: InputType.TEXT,
  },

  nomeRecebedor: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.nomeRecebedor || '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('nomeRecebedor'),
          value: model.nomeRecebedor || '-',
        },
      },
    ],
    textContent: model.nomeRecebedor || '-',
    input: InputType.TEXT,
  },

  documentoRecebedor: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.documentoRecebedor ? cpfOrCnpj(model.documentoRecebedor) : '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('documentoRecebedor'),
          value: model.documentoRecebedor ? cpfOrCnpj(model.documentoRecebedor) : '-',
        },
      },
    ],
    textContent: model.documentoRecebedor ? cpfOrCnpj(model.documentoRecebedor) : '-',
    input: InputType.TEXT,
  },

  rgRecebedor: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          value: model.rgRecebedor ? rg(model.rgRecebedor) : '-',
        },
      },
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('rgRecebedor'),
          value: model.rgRecebedor ? rg(model.rgRecebedor) : '-',
        },
      },
    ],
    textContent: model.rgRecebedor ? rg(model.rgRecebedor) : '-',
    input: InputType.TEXT,
  },
})
